import React from 'react';
import { PropTypes } from 'prop-types';
// styles
import styled, { css } from 'styled-components';
//
import { useTranslation } from 'react-i18next';

const TextContainer = styled.div`
  /* Container */

  /* Auto layout */

  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 8px;

  height: 16px;

  /* Inside auto layout */

  flex: none;
  order: 1;
  flex-grow: 0;
  /* width: 220px; */
  height: 16px;

  /* 14px/medium */

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  /* identical to box height, or 114% */

  color: var(--grey700);

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
`;

const MaxLoadReached = ({ className }) => {
  const { t } = useTranslation('Catalog');

  return (
    <div className={className}>
      <TextContainer>{t('configuration.loads.max_reached')}</TextContainer>
    </div>
  );
};

MaxLoadReached.propTypes = {
  className: PropTypes.string,
};

const regularCSS = css`
  /* Auto layout */

  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px 0px;
  gap: 8px;

  height: 36px;

  border-radius: 4px;

  /* Inside auto layout */

  flex: none;
  order: 2;
  align-self: stretch;
  flex-grow: 0;

  background: transparent;
  border: none;
  outline: none;
  /* background: red; */
  /* border: 1px solid black; */
`;

export default styled(MaxLoadReached)`
  ${regularCSS}
`;
